import mutations from "./mutations";
import actions from './actions';
import getters from './getters';

export default{
    namespaced: true,
    state(){
        return {
            ritten: [],
            numbers: null,
            pages: 0,
            wagens: ['Executive', 'Luxury', 'Luxury VIP', 'Mini-Van', 'Bus', 'Luggage Van', 'Premium SUV', 'Sprinter 15 seats', 'Sprinter Coach 20 seats', 'Coach 30 seats', 'Coach 49 seats', 'Shuttle', 'External'],
            bedrijven: [],
            customers: [],

            activeRit: null,
            activeSubReizigers: [],
            alarm:null,
            lastChauffeur: null,
            chauffeurs: [],
            activeChauffeur: null,
            tasks: []
        }
    },
    mutations,
    actions,
    getters
}